import { useTranslation } from 'react-i18next';

export function LedgerHistoryPager({
  page,
  limit,
  total,
  onPage,
}: {
  page: number;
  limit: number;
  total: number;
  onPage: (page: number) => void;
}) {
  const { t } = useTranslation('member');
  const pages = Math.max(1, Math.ceil(total / limit));
  if (pages === 1) return null;
  return (
    <div className="flex items-center justify-end gap-3 px-4 py-2 text-sm">
      <button
        type="button"
        className="min-h-11 px-3 rounded-md border border-base-300 disabled:opacity-50"
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
      >
        {t('ledgerPrev')}
      </button>
      <span className="text-base-content/60">{t('ledgerPage', { page, pages })}</span>
      <button
        type="button"
        className="min-h-11 px-3 rounded-md border border-base-300 disabled:opacity-50"
        disabled={page >= pages}
        onClick={() => onPage(page + 1)}
      >
        {t('ledgerNext')}
      </button>
    </div>
  );
}
